import {Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {QrService} from '../../shared/services/qr.service';
import {environment} from 'src/environments/environment';
import {DocumentType} from 'src/app/shared/models/user';
import {PassportType, RequestState, RequestSubState, RequestWithDuplicata} from 'src/app/shared/models/request';
import {RequestService} from 'src/app/shared/services/request.service';
import {SyncService} from '../../shared/services/sync.service';
import {PlacesService} from 'src/app/shared/services/places.service';
import {AbstractPrintComponent} from '../abstract-print/abstract-print.component';
import {LangService} from 'ngx-satoris';
import {documentTypeIsAnyVisa, documentTypeIsVisaArrivalVariant} from 'src/app/shared/models/document-type-helpers';
import {hasUiPerm} from 'src/app/shared/models/default-filter-strategy';
import {UiPermission} from 'src/app/shared/models/permission';
import {addBusinessDays} from 'date-fns';
import {hasValue} from 'src/app/shared/utils/form';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrintComponent extends AbstractPrintComponent{
  @Input() data: RequestWithDuplicata;
  @Output() init: EventEmitter<any> = new EventEmitter<void>();

  documentTypeIsVisaArrivalVariant = documentTypeIsVisaArrivalVariant;
  documentTypeIsAnyVisa = documentTypeIsAnyVisa;
  hasUiPerm = hasUiPerm;
  isValid = false;
  constructor(public api: ApiService,
              public qr: QrService,
              public sync: SyncService,
              public request: RequestService,
              private lang: LangService,
              public places: PlacesService,
              elRef: ElementRef) {
    super(elRef);
  }

  ngOnInit() {
    if(this.hasUiPerm(UiPermission.IS_STATUS_PAID_FOR_PRINT)) this.isValid = this.data && (this.data.state === RequestState.PAID || this.data.state === RequestState.USED);
    else this.isValid = this.data && (this.data.state === RequestState.PAID || this.data.state === RequestState.USED || this.data.state === RequestState.DELAY_PAY);
  }

  get isTransit(): boolean {
    return this.request.isTransit(this.data);
  }

  getUsageCount(operationId: string) {
    const count = this.api.userInfo?.server.paymentRequests.find(r => r.id === operationId)?.usageCount;
    if(count >= 100) return this.lang.transform('unlimited');
    return count;
  }

  protected readonly addBusinessDays = addBusinessDays;
  protected readonly environment = environment;
  protected readonly DocumentType = DocumentType;
  protected readonly RequestState = RequestState;
  protected readonly RequestSubState = RequestSubState;
  protected readonly PassportType = PassportType;
  protected readonly UiPermission = UiPermission;
  protected readonly hasValue = hasValue;
}
